export enum RecruiterPlanPostTypes {
    FETCH_RECRUITER_PLAN_POST_SUCCESS = "FETCH_RECRUITER_PLAN_POST_SUCCESS",
    FETCH_RECRUITER_PLAN_POST_FAILURE = "FETCH_RECRUITER_PLAN_POST_FAILURE",
    FETCH_RECRUITER_PLAN_POST_REQUEST = "FETCH_RECRUITER_PLAN_POST_REQUEST"
  }